import {VideoTileFooterDefaultBox} from "./video-tile-footer-default.box";

export const VideoTileFooterBox = VideoTileFooterDefaultBox;
